import { Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface LocaleOption {
  code: string;
  label: string;
}

// Every locale cloudlink-components-chat ships translations for
// (projects/cloudlink-components-chat/src/assets/i18n/cl-chat/).
export const AVAILABLE_LOCALES: LocaleOption[] = [
  { code: 'en', label: 'English' },
  { code: 'en-GB', label: 'English (UK)' },
  { code: 'cy-GB', label: 'Welsh' },
  { code: 'da', label: 'Danish' },
  { code: 'de-DE', label: 'German' },
  { code: 'es-ES', label: 'Spanish' },
  { code: 'es-CL', label: 'Spanish (Chile)' },
  { code: 'es-MX', label: 'Spanish (Mexico)' },
  { code: 'fi', label: 'Finnish' },
  { code: 'fr-FR', label: 'French' },
  { code: 'fr-CA', label: 'French (Canada)' },
  { code: 'it-IT', label: 'Italian' },
  { code: 'nb-NO', label: 'Norwegian (Bokmål)' },
  { code: 'nl', label: 'Dutch' },
  { code: 'no', label: 'Norwegian' },
  { code: 'pl', label: 'Polish' },
  { code: 'pt-PT', label: 'Portuguese' },
  { code: 'pt-BR', label: 'Portuguese (Brazil)' },
  { code: 'ru-RU', label: 'Russian' },
  { code: 'sv-SE', label: 'Swedish' },
  { code: 'zh', label: 'Chinese' },
  { code: 'zh-CN', label: 'Chinese (Simplified)' },
  { code: 'zh-TW', label: 'Chinese (Traditional)' }
];

// Shared between AppComponent's header language menu and ChatPageComponent's
// <mi-chat [locale]>. A plain getter over translateService.currentLang wouldn't reliably
// re-run under OnPush when the language changes from a different component (getters aren't
// tracked the way signals are) - a signal here mirrors how ThemeService does it.
@Injectable({ providedIn: 'root' })
export class LocaleService {
  readonly locale = signal<string>('en');

  constructor(private translateService: TranslateService) {}

  setLocale(code: string): void {
    this.locale.set(code);
    this.translateService.use(code);
  }
}
